


































































































































































































































































































import Vue from 'vue'
import Icon from '@/components/globals/Icon.vue'
import Button from '@/components/globals/Button.vue'
import FacilityLpBanner from '@/components/globals/FacilityLpBanner.vue'
import { GradeProgress } from '@/core/Auth'
import { GradeForecastType } from '@/core/Me'
import { Grade, passCircleImages } from '@/core/Grades'
import { logout } from '@/core/Auth'
import { StoreAuthLogout } from '@/store/modules/auth/types'
import { PartialAuthUser } from '@/store/modules/auth/getters'
import { PointSubscription } from '@/core/PointSubscriptions'

export default Vue.extend({
  components: {
    Icon,
    Button,
    FacilityLpBanner,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeTimer: null as number | null,
      isOpenState: this.isOpen,
    }
  },
  computed: {
    passCircleImages() {
      return passCircleImages
    },
    isLogin(): boolean {
      return this.$store.getters['auth/isLogin']
    },
    user(): PartialAuthUser {
      return this.$store.getters['auth/user']
    },
    point(): number {
      return this.$store.getters['auth/point']
    },
    progress(): GradeProgress | null {
      return this.$store.getters['auth/progress']
    },
    lowerGrade(): Grade | null {
      return this.progress?.lowerGrade ?? null
    },
    currentGrade(): Grade | null {
      return this.progress?.currentGrade ?? null
    },
    upperGrade(): Grade | null {
      return this.progress?.upperGrade ?? null
    },
    isGradeForcastUp(): boolean {
      return this.progress?.forecast === GradeForecastType.UP
    },
    isGradeForcastKeep(): boolean {
      return this.progress?.forecast === GradeForecastType.KEEP
    },
    isGradeForcastDown(): boolean {
      return this.progress?.forecast === GradeForecastType.DOWN
    },
    subscription(): PointSubscription | null {
      return this.$store.getters['auth/subscription']
    },
    subscriptionFailure(): PointSubscription['lastPaymentFailure'] | null {
      return this.subscription?.lastPaymentFailure ?? null
    },
    currentPassType(): string | null {
      return this.currentGrade
        ? this.currentGrade.key.replace('user_grade_', '')
        : null
    },
    usageNumUntilNextGrade(): number {
      return (
        (this.upperGrade?.monthlyReservationNumToAchieve ?? 0) -
        (this.progress?.fluctuateFactor.monthlyReservationNum ?? 0)
      )
    },
    usageNumToKeepGrade(): number {
      return (
        (this.currentGrade?.monthlyReservationNumToKeep ?? 0) -
        (this.progress?.fluctuateFactor.monthlyReservationNum ?? 0)
      )
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.isOpenState = true
      } else {
        this.closeTimer = setTimeout(() => {
          this.isOpenState = false
        }, 200)
      }
    },
  },
  beforeDestroy() {
    if (this.closeTimer !== null) {
      clearTimeout(this.closeTimer)
    }
  },
  beforeRouteLeave(): void {
    this.hideMenu()
  },
  methods: {
    hideMenu(): void {
      this.$emit('onClose')
    },
    async logout(): Promise<void> {
      this.hideMenu()
      await logout()
      this.$router
        .push(`/`)
        // 遷移を開始してからログイン状態を削除する
        .then(() => {
          this.$store.commit(new StoreAuthLogout())
        })
        .catch((_) => {})
    },
  },
})
